import React from 'react'
import './UploadFile.scss'
import { Form, Upload } from 'antd'
import Button from '../Button/Button'
import { ReactComponent as UploadIcon } from '../../assets/icons/uploadicon.svg'
import { ReactComponent as DeleteIcon } from '../../assets/icons/delete.svg'

const UploadFile = ({
  label,
  placeholder,
  name,
  onChange,
  show,
  maxCount,
  rules,
  beforeUpload,
  docNames,
  isValidSize,
  documentNames,
  buttonLabel,
}) => {
  const props = {
    name,
    onChange,
    maxCount,
    multiple: maxCount !== 1,
    beforeUpload,
    defaultFileList: documentNames?.map((docName, index) => ({
      uid: index,
      name: docName,
    })),
    showUploadList: {
      showRemoveIcon: true,
      removeIcon: <DeleteIcon />,
    },
  }

  return (
    <>
      <Form.Item
        label={label}
        name={name}
        rules={rules}
        className={`select-field text-field upload-field ${
          !isValidSize ? 'invalid-file-size' : null
        }`}
      >
        <Upload {...props} className="document-upload">
          <Button
            type={buttonLabel ? 'default' : 'link'}
            aria-label="Upload document file"
            icon={buttonLabel ? undefined : <UploadIcon aria-hidden="true" />}
            label={buttonLabel}
          />
          {show && <p>{placeholder}</p>}
        </Upload>
      </Form.Item>
      <span className={`${!isValidSize ? 'file-upload-warning' : ''} `}>
        {!isValidSize &&
          'File is too large ,please upload file less than 10 MB'}
      </span>
    </>
  )
}

export default UploadFile
